export interface IPurchasingGroupAssignmentConflictDto {
    readonly assignedPurchasingGroupId: string;
    readonly assignedPurchasingGroupCode: string;
    readonly assignedPurchasingGroupName: string;
    readonly companyCodeId: string;
    readonly companyCode: string;
    readonly materialGroupId: string;
    readonly materialGroupCode: string;
}

export class PurchasingGroupAssignmentConflict {
    public readonly assignedPurchasingGroupId: string;
    public readonly assignedPurchasingGroupCode: string;
    public readonly assignedPurchasingGroupName: string;
    public readonly companyCodeId: string;
    public readonly companyCode: string;
    public readonly materialGroupId: string;
    public readonly materialGroupCode: string;
    public readonly assignedPurchasingGroupLabel: string;

    constructor(dto: IPurchasingGroupAssignmentConflictDto) {
        this.assignedPurchasingGroupId = dto.assignedPurchasingGroupId;
        this.assignedPurchasingGroupCode = dto.assignedPurchasingGroupCode;
        this.assignedPurchasingGroupName = dto.assignedPurchasingGroupName;
        this.companyCodeId = dto.companyCodeId;
        this.companyCode = dto.companyCode;
        this.materialGroupId = dto.materialGroupId;
        this.materialGroupCode = dto.materialGroupCode;
        this.assignedPurchasingGroupLabel = buildLabel(
            this.assignedPurchasingGroupCode,
            this.assignedPurchasingGroupName,
        );
    }
}

function buildLabel(code: string, name: string): string {
    const trimmedName = name.trim();
    if (!trimmedName) {
        return code;
    }
    return `${code} - ${trimmedName}`;
}
